import { render, staticRenderFns } from "./degreeList.vue?vue&type=template&id=6705cc9e&scoped=true"
import script from "./degreeList.vue?vue&type=script&lang=js"
export * from "./degreeList.vue?vue&type=script&lang=js"
import style0 from "./degreeList.vue?vue&type=style&index=0&id=6705cc9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705cc9e",
  null
  
)

export default component.exports